var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"transparent px-2",attrs:{"elevation":"0"}},[_c('vue-html2pdf',{ref:"certifPeserta",attrs:{"enable-download":true,"preview-modal":false,"show-layout":true,"pdf-quality":2,"filename":_vm.certificateName,"pdf-orientation":"landscape","manual-pagination":true,"pdf-content-width":"100%"},on:{"hasDownloaded":function($event){return _vm.hasGenerated($event)}}},[_c('section',{attrs:{"slot":"pdf-content"},slot:"pdf-content"},[_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/bg-new-certif.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })},[(Object.keys(_vm.data).length > 0)?_c('div',{staticClass:"style1"},[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"15px"}},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":require("@/assets/images/logo-dash.png"),"alt":"","srcset":""}})]),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"bold","font-size":"26px","line-height":"47px","text-align":"center","letter-spacing":"0.015em","margin-top":"10px"}},[_vm._v(" Sertifikat Penyelesaian ")]),_c('div',{staticStyle:{"font-family":"Roboto","font-weight":"normal","font-size":"16px","line-height":"20px","text-align":"center","margin-top":"4px"}},[_vm._v(" Diberikan atas keberhasilan mengikuti dan lulus dari Kelas "),_c('br'),_vm._v(" "+_vm._s(_vm.data.program_name)+" "),_c('br'),_vm._v("Kepada ")]),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"900","font-size":"32px","line-height":"auto","text-align":"center","margin-top":"20px"}},[_vm._v(" "+_vm._s(_vm.data.user_name)+" ")]),_c('hr',{staticStyle:{"width":"35%","border":"1px solid rgba(0, 0, 0, 0.2)","margin":"auto"}}),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"400","font-size":"16px","line-height":"14px","text-align":"center","margin-top":"10px"}},[_c('div',{staticStyle:{"margin-top":"5px"}},[_vm._v("atas keberhasilan menyelesaikan program selama 15 jam")])]),(_vm.data.feedback_score >= 80)?_c('div',{staticStyle:{"font-size":"16px","font-family":"Roboto","text-align":"center","margin-top":"10px"}},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"900","padding-right":"8px"}},[_vm._v("LULUS")]),_c('span',{staticStyle:{"padding-right":"8px"}},[_vm._v("dengan predikat")]),_c('span',{staticStyle:{"font-size":"18px","font-weight":"900"}},[_vm._v("\"SANGAT BAIK\"")])]):_vm._e(),(false)?[(_vm.data.feedback_score >= 80)?_c('div',{staticStyle:{"font-family":"Roboto","font-weight":"normal","margin-top":"5px","font-size":"14px","text-align":"center"}},[_vm._v(" dengan nilai akhir: "+_vm._s(_vm.data.feedback_score)+" ")]):_vm._e()]:_vm._e(),_c('div',{staticStyle:{"width":"80%","display":"flex","margin-top":"45px","margin-left":"auto","margin-right":"auto"}},[_c('div',{staticStyle:{"width":"33%","margin":"auto"}},[_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"500","font-size":"16px","line-height":"14px","text-align":"center"}},[_c('vue-qrcode',{attrs:{"value":_vm.data.certificate_url,"options":{ color: { dark: '#4B4B4B', }, width: 100 }}}),_c('div',[_vm._v(_vm._s(_vm.data.certificate_number))])],1)]),_c('div',{staticStyle:{"width":"33%","margin":"0 5%","margin-right":"0"}},[_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"bold","font-size":"16px","line-height":"16px","text-align":"center","margin-bottom":"5px","/*margin-top":"30px"}},[_vm._v(" Yogyakarta, "+_vm._s(_vm.currentDateTime(_vm.data.end_test_at))+" ")]),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"400","font-size":"14px","line-height":"14px","text-align":"center","/*margin-top":"29px"}},[_vm._v(" Director, ")]),_c('div',{staticStyle:{"margin-top":"10px","text-align":"center"}},[_c('img',{attrs:{"width":"50%","src":require("@/assets/images/ttd-ytc.png"),"alt":"","srcset":""}})]),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"500","font-size":"16px","line-height":"14px","text-align":"center","margin-top":"6px"}},[_vm._v(" M. Animna Husna, S.I.A. ")])]),_c('div',{staticStyle:{"width":"33%","margin":"auto auto auto 3.2rem"}},[_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"500","font-size":"14px","line-height":"16px"}},[(this.data.is_prakerja === true)?_c('div',[_c('p',{staticStyle:{"text-align":"left","margin-bottom":"10px"}},[_vm._v("Diverifikasi oleh : ")]),_c('img',{staticStyle:{"width":"60%","text-align":"left"},attrs:{"src":require("@/assets/images/prakerja-new.png"),"alt":"","srcset":""}})]):_vm._e()])])])],2):_vm._e()]),(_vm.data.program_name == 'Merencanakan Strategi Pemasangan Iklan di Media Sosial Untuk Menjadi Manajer Periklanan')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Merencanakan Strategi Pemasangan Iklan di Media Sosial Untuk Menjadi Manajer Periklanan.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menyusun Surat Perjanjian Bahasa Inggris bagi Calon Staf Legal')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menyusun Surat Perjanjian Bahasa Inggris bagi Calon Staf Legal.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name.toLowerCase() == 'Layanan Pelanggan Berbasis Digital'.toLowerCase())?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Layanan Pelanggan Berbasis Digital.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name.toLowerCase() == 'Pelayanan Prima untuk Customer Service Online'.toLowerCase())?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Pelayanan Prima untuk Customer Service Online.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name.toLowerCase() == 'Mengelola Dokumen untuk Staf Perkantoran'.toLowerCase())?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Mengelola Dokumen untuk Staf Perkantoran.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name.toLowerCase() == 'Dasar Keselamatan dan Kesehatan Kerja di Tempat Kerja'.toLowerCase())?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/[11_07_2023] Dasar Keselamatan dan Kesehatan Kerja di Tempat Kerja (2).png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menghitung Gaji Bersih di Excel untuk HR')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Menghitung Gaji Bersih di Excel untuk HR.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Komunikasi Efektif dan Negosiasi Bagi Staf Penjualan')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Komunikasi Efektif dan Negosiasi Bagi Staf Penjualan.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name.toLowerCase() == 'Menghitung Tunjangan di Excel untuk HR'.toLowerCase())?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menghitung Tunjangan di Excel untuk HR.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menyusun Surat Bisnis dalam Bahasa Inggris Bagi Calon Sekretaris')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menyusun Surat Bisnis dalam Bahasa Inggris Bagi Calon Sekretaris.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menyusun Laporan Keuangan dengan Microsoft Excel untuk Menjadi Staf Akuntan')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menyusun Laporan Keuangan dengan Microsoft Excel untuk Menjadi Staf Akuntan.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Mengolah Data Penjualan dengan Microsoft Excel untuk Menjadi Admin Input Data')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Mengolah Data Penjualan dengan Microsoft Excel untuk Menjadi Admin Input Data.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menggunakan Bahasa Inggris Bagi Calon Tenaga Perkantoran Umum')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menggunakan Bahasa Inggris Bagi Calon Tenaga Perkantoran Umum.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menggunakan Bahasa Inggris Bagi Calon Sekretaris')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menggunakan Bahasa Inggris Bagi Calon Sekretaris.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name.toLowerCase() == 'Pengelolaan Akuntansi Dan Perpajakan Bagi Akuntan Untuk UMKM'.toLowerCase())?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Pengelolaan Akuntansi dan Perpajakan bagi Akuntan untuk UMKM.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Mengembangkan Konten di Media Sosial Untuk Menjadi Spesialis Pemasaran Digital')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Mengembangkan Konten di Media Sosial Untuk Menjadi Spesialis Pemasaran Digital.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Mengelola Gaji Karyawan dengan Microsoft Excel Untuk Menjadi Staf Personalia')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Mengelola Gaji Karyawan dengan Microsoft Excel Untuk Menjadi Staf Personalia.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Melakukan Riset Kata Kunci dan Optimasi SEO Website Untuk Menjadi Manajer Pemasaran')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Melakukan Riset Kata Kunci dan Optimasi SEO Website Untuk Menjadi Manajer Pemasaran.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Melakukan Komunikasi Bahasa Inggris Melalui Panggilan Telepon Bagi Calon Petugas Informasi Pusat Kontak')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Melakukan Komunikasi Bahasa Inggris Melalui Panggilan Telepon Bagi Calon Petugas Informasi Pusat Kontak.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Mengelola Kinerja Karyawan Untuk Menjadi Manajer Sumber Daya Manusia')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Mengelola Kinerja Karyawan Untuk Menjadi Manajer Sumber Daya Manusia.jpg')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Merumuskan Kebijakan Organisasi dan Strategi Pengelolaan SDM Untuk Menjadi Manajer Sumber Daya Manusia')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Merumuskan Kebijakan Organisasi dan Strategi Pengelolaan SDM Untuk Menjadi Manajer Sumber Daya Manusia.jpg')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Strategi Pemasaran Untuk Spesialis Pengembangan Bisnis')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Strategi Pemasaran Untuk Spesialis Pengembangan Bisnis.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Merancang Desain Konten Untuk Desainer Grafis')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Merancang Desain Konten Untuk Desainer Grafis.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Desain Logo dan Konten Untuk Desainer Grafis')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/desain-logo-dan-konten-untuk-desainer-grafis.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Kepuasan Pelanggan untuk Kasir')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Kepuasan Pelanggan untuk Kasir.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Microsoft Excel untuk Staf Admin')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/microsoft-excel-untuk-staf-admin.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Dasar Keselamatan dan Kesehatan Kerja di Tempat Kerja')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Dasar Keselamatan Dan Kesehatan Kerja Di Tempat Kerja.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Bahasa Inggris Untuk Karyawan')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/bahasa-inggris-untuk-karyawan.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Bahasa Inggris Untuk Legal')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/bahasa-inggris-untuk-legal-belakang.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Bahasa Inggris untuk Administrasi dan Legalitas Perkantoran')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/bahasa-inggris-untuk-adminsitrasi-dan-legalitas-perkantoran-belakang.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Komunikasi Pelanggan Untuk Kasir')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Komunikasi Pelanggan Untuk Kasir-2.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Komunikasi Publik Untuk Customer Service')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Komunikasi Publik Untuk Customer Service.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Pelayanan Prima Untuk Staf Toko')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Pelayanan Prima Untuk Staf Toko.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Mengelola Gaji Karyawan dengan Microsoft Excel')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Mengelola Gaji Karyawan Dengan Microsoft Excel.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Menyusun Surat Bisnis dalam Bahasa Inggris bagi Calon Sekretaris')?_c('section',{staticClass:"pdf-item",style:({
          backgroundImage: `url('${require('@/assets/images/certificate/Menyusun Surat Bisnins Dalam Bahasa Inggris Bagi Calon Sekretaris.png')}')`,
          backgroundSize: `100% 100%`,
          backgroundPosition: `center center`,
          backgroundRepeat: `no-repeat`,
          width: `100%`,
          height: `790px`,
          color: `#4B4B4B`,
        })}):(_vm.data.program_name == 'Kepuasan Pelanggan untuk Staf Toko')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Kepuasan Pelanggan untuk Staf Toko.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name == 'Pelayanan Pelanggan untuk Customer Service')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Pelayanan Pelanggan untuk Customer Service .png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):(_vm.data.program_name.toLowerCase() == 'mengelola dokumen untuk staf perkantoran umum')?_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/certificate/Mengelola Dokumen untuk Staf Perkantoran.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })}):_c('section',{staticClass:"pdf-item",style:({
        backgroundImage: `url('${require('@/assets/images/bg-new-certif.png')}')`,
        backgroundSize: `100% 100%`,
        backgroundPosition: `center center`,
        backgroundRepeat: `no-repeat`,
        width: `100%`,
        height: `790px`,
        color: `#4B4B4B`,
      })},[(Object.keys(_vm.data).length > 0)?_c('div',{staticStyle:{"padding-top":"200px"}},[_c('div',{staticStyle:{"text-align":"center","margin-bottom":"15px"}},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":require("@/assets/images/logo-dash.png"),"alt":"","srcset":""}})]),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"bold","font-size":"26px","line-height":"47px","text-align":"center","letter-spacing":"0.015em","margin-top":"10px"}},[_vm._v(" KOMPETENSI YANG DILATIH ")]),_c('div',{staticStyle:{"font-family":"Roboto","font-weight":"normal","font-size":"16px","line-height":"20px","text-align":"center","margin-top":"4px"}},[_vm._v(" "+_vm._s(_vm.data.program_name)+" ")]),_c('div',{staticStyle:{"font-family":"Roboto","font-style":"normal","font-weight":"400","font-size":"14px","line-height":"16px","text-align":"left","margin-top":"30px","display":"flex","justify-content":"center"}},[_c('div',[_c('p',{staticStyle:{"font-weight":"bold","font-size":"16px","text-align":"center","margin-bottom":"10px","margin-top":"0px"}},[_vm._v(" Kompetensi")]),_vm._l((_vm.data.competence),function(item,index){return _c('div',{key:index,staticStyle:{"padding-left":"0px","margin-left":"0px"}},[_c('p',{staticStyle:{"margin-bottom":"2px","font-size":"14px"}},[_vm._v(" "+_vm._s(index + 1)+". "+_vm._s(item)+" ")])])})],2)])]):_vm._e()])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }